import { fetchApi } from '@/config/axiosSetting';
import { DeleteAdjusterOtherDamagedImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteAdjusterOtherDamagedImages/deleteAdjusterOtherDamagedImagesQuery.type';

export const deleteAdjusterOtherDamagedImagesFunction = (
  params: DeleteAdjusterOtherDamagedImagesQueryParamsType,
): Promise<{}> => {
  const data = new FormData();
  data.append('image_id', params.image_id);
  return fetchApi({
    method: 'DELETE',
    url: `property/reports/${params.id}/accident_users/damaged/adjuster/damaged/`,
    data,
    params: { damaged_id: params.damagedId },
  });
};
